import React from "react"
import Navbar from "./navbar.js"
import Main from "./Main.js"
export default function Home(){
    return (
        <div>
            <Navbar/>
            <Main/>
        </div>
         )

}